document.addEventListener('DOMContentLoaded', function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function parseDiscountDate(value) {
    if (!value) return null;
    var normalized = String(value).trim().replace(' ', 'T');
    var date = new Date(normalized);
    if (Number.isNaN(date.getTime())) {
      date = new Date(String(value).replace(/-/g, '/'));
    }
    return Number.isNaN(date.getTime()) ? null : date;
  }

  function formatCountdown(remainingMs, daysLabel, dayLabel, endsInLabel) {
    if (remainingMs <= 0) return null;

    var totalSeconds = Math.floor(remainingMs / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var timePart = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);

    if (days > 0) {
      var dayText = days === 1 ? dayLabel : daysLabel;
      return endsInLabel.replace('[time]', days + ' ' + dayText + ' ' + timePart);
    }

    return endsInLabel.replace('[time]', timePart);
  }

  $(document).on('click', '.dicount_code_info .copy', function () {
    var $btn = $(this);
    var $link = $btn.siblings().find('a').first();
    if (!$link.length) {
      $link = $btn.closest('.dicount_code_info').find('a').first();
    }
    if (!$link.length) return;

    var href = ($link.attr('href') || '').split('?')[0];
    var code = href.substring(href.lastIndexOf('/') + 1).trim();
    if (!code) return;

    navigator.clipboard.writeText(code);
    var original = $btn.data('label') || $btn.find('span').text();
    var copied = $btn.data('copied-label') || 'COPIED';
    $btn.find('span').text(copied);
    setTimeout(function () {
      $btn.find('span').text(original);
    }, 2000);
  });

  function updateModuleVisibility(startTime, endTime, module) {
    var currentTime = new Date();
    if (currentTime < startTime || currentTime > endTime) {
      if (module.length > 0) {
        module.css('display', 'none');
      }
    }
  }

  if ($('.product_discount_message[data-class-groups]').eq(0).length > 0) {
    var class_groups = $('.product_discount_message[data-class-groups]').eq(0).data('class-groups').split(',');
    for (var i = 0; i < class_groups.length; i++) {
      var module = $('.product_discount_message.' + class_groups[i]).eq(0);
      if ($(module).length > 0) {
        var start_time = parseDiscountDate(module.data('start-time'));
        var end_time = parseDiscountDate(module.data('end-time'));
        if (!start_time || !end_time) continue;
        updateModuleVisibility(start_time, end_time, $('.product_discount_message.' + class_groups[i]));
        (function (startTime, endTime, selector) {
          setInterval(function () {
            updateModuleVisibility(startTime, endTime, $(selector));
          }, 1000);
        })(start_time, end_time, '.product_discount_message.' + class_groups[i]);
      }
    }
  }

  function initCountdowns() {
    var nodes = document.querySelectorAll('.discount-coupon__countdown[data-countdown-end]');
    if (!nodes.length) return;

    function tick() {
      nodes.forEach(function (node) {
        var end = parseDiscountDate(node.getAttribute('data-countdown-end'));
        var textEl = node.querySelector('.discount-coupon__countdown-text');
        if (!end || !textEl) return;

        var endsInLabel = node.getAttribute('data-ends-in') || 'Ends in [time]';
        var dayLabel = node.getAttribute('data-day') || 'Day';
        var daysLabel = node.getAttribute('data-days') || 'Days';
        var endedLabel = node.getAttribute('data-ended') || 'Ended';
        var remaining = end.getTime() - Date.now();
        var label = formatCountdown(remaining, daysLabel, dayLabel, endsInLabel);
        if (!label) {
          textEl.textContent = endedLabel;
          node.classList.add('is-ended');
          return;
        }
        textEl.textContent = label;
        node.classList.remove('is-ended');
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  initCountdowns();
});
